import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { Search } from 'react-feather';
import { useArticleSearchPath } from '../../context';

export const ArticleSearchButton = (props: {
  borderColor?: ouiStyle.InStyle['borderColor'],
}) => {
  const {
    borderColor = ouiStyle.Constants.Colors.inverted,
  } = props;
  const to = useArticleSearchPath();
  return (
    <ouiDom.A.AButton
      to={to}
      color={ouiStyle.Constants.Colors.primary}
      paddingVertical="simple"
      paddingLeft="double"
      paddingRight="double"
      borderTopRightRadius="full"
      borderBottomRightRadius="full"
      borderTopColor={borderColor}
      borderBottomColor={borderColor}
      borderRightColor={borderColor}
      borderLeftColor={ouiStyle.Constants.Colors.fade}
    >
      <Search />
    </ouiDom.A.AButton>
  );
};
